var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel-wrapper" }, [
    _c(
      "div",
      { staticClass: "panel-header" },
      [
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: {
                  placeholder: "请选择方案",
                  value: _vm.planId,
                  size: "mini"
                },
                on: { change: _vm.planChange }
              },
              _vm._l(_vm.plans, function(item) {
                return _c("el-option", {
                  key: item.planId,
                  attrs: { label: item.planName, value: item.planId }
                })
              }),
              1
            )
          ],
          1
        ),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.exportReports } },
          [_vm._v("下载报告")]
        ),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.goToProject } },
          [_vm._v("返回项目")]
        )
      ],
      1
    ),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "height-area" }, [
        _c("div", { staticStyle: { width: "60px" } }, [_vm._v("高度")]),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择高度" },
                on: { change: _vm.handleDataHeightChange },
                model: {
                  value: _vm.datasetHeight,
                  callback: function($$v) {
                    _vm.datasetHeight = $$v
                  },
                  expression: "datasetHeight"
                }
              },
              _vm._l(_vm.heightList, function(v, i) {
                return _c("el-option", {
                  key: i,
                  attrs: { label: v + "m", value: v }
                })
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm.simpleValues.length > 0 && !_vm.loading
        ? _c(
            "div",
            { staticClass: "pic-area", attrs: { id: "my-node" } },
            [
              _c("el-checkbox", {
                attrs: { label: "风速" },
                on: {
                  change: function($event) {
                    return _vm.checkboxChange(_vm.btnList[0])
                  }
                },
                model: {
                  value: _vm.isElementChecked,
                  callback: function($$v) {
                    _vm.isElementChecked = $$v
                  },
                  expression: "isElementChecked"
                }
              }),
              _c("color-simple", {
                attrs: {
                  type: "horizontal",
                  colors: _vm.colors,
                  values: _vm.simpleValues,
                  unit: _vm.activeUnit,
                  width: "100%"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.turbine
        ? _c(
            "div",
            { staticClass: "tower-info-container" },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "风机：" + _vm._s(_vm.turbine ? _vm.turbine.turbineNo : "")
                )
              ]),
              _c("tower-info", { attrs: { turbine: _vm.turbine } })
            ],
            1
          )
        : _vm._e(),
      _vm.tower
        ? _c(
            "div",
            { staticClass: "point-info-container" },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "测风塔概况" + _vm._s(_vm.tower ? _vm.tower.towerNo : "")
                )
              ]),
              _c("point-info", {
                attrs: { info: _vm.tower, datasetHeight: _vm.datasetHeight }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }